import KumosearchError from "./KumosearchError";

export default class ObjectAlreadyExists extends KumosearchError {}
